import React from "react";
import { TrendingUp, Clock, Gauge, Banknote } from "lucide-react";

export function Stats({ te }) {
  const items = [
    { ...te.new_stats.callbacks, icon: TrendingUp },
    { ...te.new_stats.hired, icon: Clock },
    { ...te.new_stats.points, icon: Gauge },
    { ...te.new_stats.pay, icon: Banknote },
  ];
  return (
    <section className="py-8 lg:py-20 bg-[#F2EBE1]/60 border-y border-[#EAE5DB]" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 lg:gap-12">
        {items.map((it, i) => (
          <div key={i} className="flex items-start gap-3 lg:gap-4">
            <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl bg-white border border-[#EAE5DB] flex items-center justify-center flex-shrink-0">
              <it.icon className="w-5 h-5 text-[#D95D39]" />
            </div>
            <div>
              <div className="font-heading font-extrabold text-3xl lg:text-4xl text-[#292524] leading-none mb-2">
                {it.n}
              </div>
              <div className="text-[#57534E] text-sm leading-relaxed">{it.t}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
